import React from 'react';

const EmptyQna = () => {
  return (
    <div className='flex flex-col justify-center items-center tabletH:p-10 h-[180px] tabletH:h-[380px]'>
      <div className='tabletH:pb-6 w-[570px] flex items-center justify-center text-text-placeholder'>
        No Q&A yet
      </div>
    </div>
  );
};

export default EmptyQna;
